import {toastMessage} from "@/utils/appInstance";

export function limpaFormularioCep(form) {
    // Limpa valores do formulário de CEP.
    form.endereco = "";
    form.bairro = "";
    form.cidade = "";
    form.uf = "";
}

export async function buscarCep(cep, form) {
    // Remove caracteres não numéricos do CEP.
    cep = cep.replace(/\D/g, "");

    // Verifica se o campo CEP possui valor informado.
    if (cep !== "") {
        // Expressão regular para validar o CEP.
        const validaCep = /^[0-9]{8}$/;

        // Valida o formato do CEP.
        if (validaCep.test(cep)) {
            // Preenche os campos com "..." enquanto consulta o webservice.
            form.endereco = "...";
            form.bairro = "...";
            form.cidade = "...";
            form.uf = "...";

            try {
                // Consulta o webservice viacep.com.br
                const response = await fetch(`https://brasilapi.com.br/api/cep/v1/${cep}`);
                const dados = await response.json();

                if (!dados.erro) {
                    // Atualiza os campos com os valores da consulta.
                    form.endereco = dados.street?.toUpperCase() || "";
                    form.bairro = dados.neighborhood?.toUpperCase() || "";
                    form.cidade = dados.city?.toUpperCase() || "";
                    form.uf = dados.state?.toUpperCase() || "";
                } else {
                    // CEP pesquisado não foi encontrado.
                    limpaFormularioCep(form);
                    toastMessage("warn", "CEP não encontrado.", "Tente novamente.");
                }
            } catch (error) {
                console.error("Erro ao buscar o CEP:", error);
                toastMessage("warn", "Erro na consulta.", "Tente novamente mais tarde.");
            }
        } else {
            // CEP é inválido.
            limpaFormularioCep(form);
            toastMessage("warn", "Formato de CEP inválido.", "Informe um formato válido.");
        }
    } else {
        // CEP sem valor, limpa o formulário.
        limpaFormularioCep(form);
    }
}
